import { Button, PageHeader } from 'components';
import { Form, Input, Row, Col, Divider, Select, Spin } from 'antd';
import styles from './style.module.scss';
import { Editor } from '@tinymce/tinymce-react';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import usePages from '../usePages';
import ErrorHelper from 'helpers/ErrorHelper';

const { Option } = Select;

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const { singleData, shoppingCenters, form, handleCreateOrUpdate, loading } =
    usePages(false);

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const title = isNew ? t('CREARE TESTI MYSHOP') : t('MODIFICA TESTI MYSHOP');

  const handleEditorChange = (e) => {
    form.setFields([
      {
        name: 'body',
        value: e.target.getContent(),
      },
    ]);
    ErrorHelper.setErrors([]);
  };

  const handleCreate = () => {
    form.submit();
  };

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          <Form
            form={form}
            onFieldsChange={(changedFields) => {
              form.setFields([
                {
                  name: changedFields[0].name[0],
                  errors: [],
                },
              ]);
            }}
            name='basic'
            wrapperCol={{
              span: 24,
            }}
            initialValues={{
              body: '',
              title: '',
              slug: '',
              shopping_center_id: '',
            }}
            layout={'vertical'}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item label={t('Titolo')} name='title'>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label={t('Url')} name='slug'>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={t('Shopping center')}
                  name='shopping_center_id'
                >
                  <Select placeholder={'Selezioni opzione'}>
                    {shoppingCenters.map((i) => (
                      <Option key={i.id} value={i.id}>
                        {i.title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item hidden name='body'>
                  <Input.TextArea />
                </Form.Item>
                <Editor
                  apiKey='y4qiwpjqismb8n0ox89rpjv9gort076zw0yviiamon1rtdps'
                  initialValue={singleData.body}
                  init={{
                    height: 400,
                    menubar: false,
                    plugins: [
                      'advlist autolink lists link image',
                      'charmap print preview anchor help',
                      'searchreplace visualblocks code',
                      'insertdatetime media table paste wordcount',
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | help',
                  }}
                  onChange={handleEditorChange}
                />
              </Col>
              <Divider />
            </Row>
          </Form>
          <Divider />
        </Spin>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={handleCreate}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={loading}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Edit;
